import React from 'react';
import { Button } from 'react-bootstrap';
import { FaRegEdit } from "react-icons/fa";

const InfoRow = ({ label, value, onEdit, isAttachment, render }) => (
    
    <div className={`form-group d-flex justify-content-between col-sm-6 custom-card-border ${isAttachment ? 'flex-wrap' : ''}`}>
        <label className="form-label custom-font-color">{label}:</label>
        &nbsp;
        <span className='d-flex'>
            <label>{render ? render(value) : value || `N/A`}</label>
            {onEdit && (
                <span>
                    <Button size="sm" className="btnC" onClick={onEdit}>
                        <FaRegEdit size={15} className="mb-2"   />
                    </Button>
                </span>
            )}
        </span>
    </div>
    
);

const ViewCard = ({ data, fields, handleShowStatusModal, handleShowPriorityModal }) => {

    return (
        <div className="col-12 col-md-12 col-lg-8">
            <div className="container card p-4 d-flex">
                <div className="row">
                    {fields?.map((field, index) => (
                        <InfoRow
                            key={index}
                            label={field.label}
                            value={data?.[field.key]}
                            render={field.render}
                            onEdit={field.key === 'status' ? handleShowStatusModal : field.key === 'priority' ? handleShowPriorityModal : null}
                            isAttachment={field.key === 'attachment' || field.key === 'description'}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
};

export default ViewCard;
